let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("04MW0")).then(() => parcelRequire('ktEhW'));